// ========== frontend/src/pages/Buy_checkout_no_influencer.js

import Header from "../Header";
import Footer from "../Footer";
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import '../css/checkout.css';

// Cover art per format — previously every branch pointed at the same
// paperback image regardless of what was actually purchased.
const BOOK_IMAGES = {
  EBOOK: 'images/book/1.png',
  AUDIOBOOK: 'images/book/audio_home2.png',
  PAPERBACK: '/images/new_images/3.png',
  HARDCOVER: '/images/new_images/3.png',
};

const FORMAT_LABELS = {
  EBOOK: 'eBook',
  AUDIOBOOK: 'Audiobook',
  PAPERBACK: 'Paperback',
  HARDCOVER: 'Hardcover',
};

function Buy_checkout() {
  const navigate = useNavigate();
  const { state } = useLocation();

  // All hooks must run unconditionally on every render (Rules of Hooks),
  // so these are declared before the early-return guard below rather than
  // after it.
  const [success, setSuccess] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [orderID, setOrderID] = useState(false);

  // Direct/refresh navigation with no order in hand — nothing to check
  // out, send them back to pick a format instead of crashing on state.type.
  if (!state) {
    return <Navigate to="/BuyBook" replace />;
  }

  const ID_ACHAT = Date.now();

  //  =========================
  // 1 $7
  // 2  $10.55
  // 3-4  $12.99
  // 5-11  $20.99
  // 12- free
  //  =========================

  let TOTAL;
  let shipping; // Declaring shipping outside the if-else block

  if ((state.type === 'PAPERBACK' || state.type === 'HARDCOVER') && (state.country === 'USA' || state.country === 'Canada')) {
    if (state.qty == 1) {
      shipping = 7.99;
    }
    if (state.qty == 2) {
      shipping = 10.99;
    }
    if (state.qty == 3) {
      shipping = 13.99;
    }
    if (state.qty >= 4 && state.qty <= 5) {
      shipping = 16.99;
    }
    if (state.qty >= 6 && state.qty <= 10) {
      shipping = 22.99;
    }
    if (state.qty >= 11 && state.qty <= 20) {
      shipping = 34.99;
    }
    if (state.qty >= 21 && state.qty <= 35) {
      shipping = 49.99;
    }
    if (state.qty >= 36 && state.qty <= 50) {
      shipping = 69.99;
    }
    if (state.qty >= 51 && state.qty <= 75) {
      shipping = 99.99;
    }
    if (state.qty >= 76 && state.qty <= 99) {
      shipping = 139.99;
    }
    if (state.qty >= 100) {
      shipping = 0;
    }

    TOTAL = state.amount + shipping;
  } else if (state.type === 'PAPERBACK' || state.type === 'HARDCOVER') {
    shipping = 48;
    TOTAL = state.amount + shipping;
  } else {
    TOTAL = state.amount;
  }

  const isPhysical = state.type === 'PAPERBACK' || state.type === 'HARDCOVER';
  const bookImage = BOOK_IMAGES[state.type] || BOOK_IMAGES.PAPERBACK;
  const formatLabel = FORMAT_LABELS[state.type] || state.type;

  // creates a paypal order
  const createOrder = (data, actions) => {
    setErrorMessage("");
    return actions.order
      .create({
        purchase_units: [
          {
            description: "Sunflower",
            amount: {
              currency_code: "USD",
              value: Number(TOTAL).toFixed(2),
            },
          },
        ],
        // not needed if a shipping address is actually needed
        application_context: {
          shipping_preference: "NO_SHIPPING",
        },
      })
      .then((orderID) => {
        setOrderID(orderID);
        return orderID;
      });
  };

  // check Approval
  const onApprove = (data, actions) => {
    setProcessing(true);
    return actions.order.capture().then(function (details) {
      setSuccess(true);

      window.location.replace('https://juniorpersist.com/public/public/store_PreOrder_no_influencer?name=' + state.name
      // window.location.replace('http://127.0.0.1:8000/store_PreOrder_no_influencer?name=' + state.name
        + '&order_id=' + ID_ACHAT
        + '&phone=' + state.phone
        + '&email=' + state.email
        + '&type=' + state.type
        + '&qty=' + state.qty
        + '&amount=' + TOTAL
        + '&description=' + state.description

        + '&influencer_id=' + state.influencer_id
        + '&street=' + state.street
        + '&city=' + state.city
        + '&state_province=' + state.state_province
        + '&postal_ZIP_code=' + state.postal_ZIP_code
        + '&country=' + state.country

      );
    }).catch(() => {
      setProcessing(false);
      setErrorMessage("We couldn't confirm your PayPal payment. Please try again.");
    });
  };

  //capture likely error
  const onError = (data, actions) => {
    setProcessing(false);
    setErrorMessage("An error occurred with your payment. Please try again, or use the Stripe option below.");
  };


  return (
    <PayPalScriptProvider
      options={{
        //  LIVE
        "client-id": "AVRfkzj1lNDb1NLTdQBgf2qLz6jppRDP3AG8lDF31MKm22LTJie4kAT_KC_vQYIgfITBwMD228DqJt1a&disable-funding=paylater,venmo,card",

        //  SANBOX
        // "client-id": "AVWTBxdPJ6aLgCU2JRyxqLHjcUyRNKyuZIeuhuwa_pPGwwUtHT_Vbw76Kt90t0AAr6Mtn2FEbun2KZxV&disable-funding=paylater,venmo,card",
      }}
    >
      <div className="checkout-page">
        <Header />

        {processing && (
          <div className="checkout-processing">
            <div className="spinner" />
            <p>Confirming your payment…</p>
          </div>
        )}

        <div className="checkout-hero">
          <div className="eyebrow"><i className="bi bi-lock-fill" /> Secure Checkout</div>
          <h1>You're almost there</h1>
        </div>

        {ErrorMessage && (
          <div className="checkout-error-banner">
            <div className="inner">{ErrorMessage}</div>
          </div>
        )}

        <div className="checkout-grid">
          {/* ===== Order summary ===== */}
          <div className="checkout-card">
            <h2>Order summary</h2>

            <div className="checkout-book-preview">
              <img src={bookImage} alt={`Persist, Persist, Persist — ${formatLabel}`} />
              <div>
                <div className="checkout-format-badge">{formatLabel}</div>
                <div className="title">Persist, Persist, Persist.</div>
              </div>
            </div>

            <div className="checkout-summary-row">
              <span>Price</span>
              <span>${Number(state.amount / state.qty).toFixed(2)} &times; {state.qty}</span>
            </div>
            <div className="checkout-summary-row">
              <span>Subtotal</span>
              <span>${Number(state.amount).toFixed(2)}</span>
            </div>
            {isPhysical && (
              <div className="checkout-summary-row">
                <span>Shipping</span>
                <span>{shipping == 0 ? 'Free' : `$${Number(shipping).toFixed(2)}`}</span>
              </div>
            )}
            <div className="checkout-summary-row">
              <span>Taxes</span>
              <span>Included</span>
            </div>

            <div className="checkout-total-row">
              <span className="label">Total</span>
              <span className="value">${Number(TOTAL).toFixed(2)} USD</span>
            </div>

            {state.description && <div className="checkout-note">"{state.description}"</div>}
          </div>

          {/* ===== Payment ===== */}
          <div className="checkout-card">
            <h2>Your information</h2>

            <div className="checkout-customer">
              <div className="name">{state.name}</div>
              <span className="detail">{state.phone}</span>
              <span className="detail">{state.email}</span>
            </div>

            <div className="checkout-paypal-wrap">
              <PayPalButtons style={{ layout: "vertical" }} createOrder={createOrder} onApprove={onApprove} onError={onError} />
            </div>

           <div className="checkout-or-divider">or</div>


            {/* <form method="post" action="http://127.0.0.1:8000/order/stripe">  */}
            <form method="post" action="https://juniorpersist.com/public/public/order/stripe">
              <input type="hidden" name="name" value={state.name} />
              <input type="hidden" name="phone" value={state.phone} />
              <input type="hidden" name="email" value={state.email} />
              <input type="hidden" name="type" value={state.type} />
              <input type="hidden" name="qty" value={state.qty} />
              <input type="hidden" name="description" value={state.description} />
              <input type="hidden" name="influencer_id" value={state.influencer_id} />
              <input type="hidden" name="street" value={state.street} />
              <input type="hidden" name="city" value={state.city} />
              <input type="hidden" name="state_province" value={state.state_province} />
              <input type="hidden" name="postal_ZIP_code" value={state.postal_ZIP_code} />
              <input type="hidden" name="amount" value={Number(TOTAL).toFixed(2)} />
              <input type="hidden" name="country" value={state.country} />

              <button className="checkout-stripe-btn" type="submit">
                <div className="checkout-stripe-label"><i className="bi bi-credit-card-fill" /> Pay with card via Stripe</div>
              </button>
            </form> 

            <div className="checkout-payment-icons">
              <img src={"/images/icons/payment_new.png"} alt="Accepted payment methods" />
            </div>
          </div>
        </div>

        <div className="checkout-trust-row">
          <span><i className="bi bi-shield-lock-fill" /> 256-bit encrypted checkout</span>
          <span><i className="bi bi-arrow-counterclockwise" /> Questions? junior@juniorpersist.com</span>
        </div>

        <br />

        <Footer />
      </div>
    </PayPalScriptProvider>
  )
}


export default Buy_checkout
